import { atom } from 'recoil';

import { FilterModalTypes } from '../../components/FilterModal';
import { OrderByModalTypes } from '../../components/OrderByModal';

export const reportGeneratorFiltersAtom = atom<FilterModalTypes.FilterAtom>({
  key: 'reportGenerator/filterSelections',
  default: {
    availableFilters: [],
    selectedFilters: [],
    appliedFilters: [],
  },
});

export const reportGeneratorOrderByModalAtom = atom<OrderByModalTypes.OrderByAtom>({
  key: 'reportGenerator/orderByModal',
  default: {
    availableOrderBy: [],
    selectedOrderBy: undefined,
    appliedOrderBy: undefined,
  },
});
